import script from "./form_news_bulk.vue?vue&type=script&setup=true&lang=ts"
export * from "./form_news_bulk.vue?vue&type=script&setup=true&lang=ts"

import "./form_news_bulk.vue?vue&type=style&index=0&id=695a40bf&scoped=true&lang=css"

import exportComponent from "/home/kuradmin/frontend-siputra/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-695a40bf"]])

export default __exports__